module.exports = __webpack_public_path__ + "img/Borrowing_Time_Industry_Must_Converge_on_Margin_Call_Automation.f362f01f.jpg";